import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/dashboard/leaderboard")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/dashboard/progress" />;
}
